import { Component, Input, Output, EventEmitter } from '@angular/core';
import { BaseFormComponent } from '../../base-form.component';
import { CommonFunctions } from 'src/app/shared/common/common-functions';
import { CodeDisplayModel } from '../../dropdown-fields/dropdown-field/dropdown-field.component';


@Component({
  selector: 'app-list-radio-field[formGroup][propertyName]',
  templateUrl: './list-radio-field.component.html',
  styles: [],
  standalone: false,
})

export class ListRadioFieldComponent extends BaseFormComponent { 
  @Input() subText?: string; 
  @Input() listData?: CodeDisplayModel[];
  @Output() userInput? = new EventEmitter<string>();
  @Input() FIELD_SPACING: number

  constructor(private commonFunctions: CommonFunctions ) {
    super(commonFunctions);
  }

  userAction(code: string, isChecked: boolean) {
    this.userInput.emit(code);
  } 
  
}
